import AdminEditArticlePage from './AdminEditArticlePage';

export default AdminEditArticlePage;
